import {Drawer} from '@breuni-ui/drawer';
import {safeDefine} from "@breuni-ui/safe-define";

export class EntsDrawer extends Drawer {
  show(): void {
    this.removeAttribute('hidden');
    super.show();
  }

  async hide(): Promise<void> {
    await super.hide();
    this.setAttribute('hidden', '');
  }
}

safeDefine('ents-drawer', EntsDrawer);
